/* GFS sitewide press feedback helper (2026-10-24). Pairs with gfs-press.css.
   - iOS Safari only fires :active when a touch listener exists -> passive no-op touchstart.
   - Adds .gfs-press on pointer down and keeps it >=120ms so quick taps still show the press. */
(function(){
  if(window.__gfsPress)return;window.__gfsPress=true;
  var SEL='button,[role="button"],input[type="submit"],input[type="button"],input[type="reset"],summary,.hdt-btn,.btn,.add,label.hdt-product-form_value,label.hdt-color-list-color,.hdt-pagination__item,header a,.hdt-page-cart__remove,a[class*="hdt-social-"],hdt-wishlist,hdt-compare,label[class*="swatch"],a[class*="swatch"],.swiper-pagination-bullet,.flickity-page-dots .dot,.slick-dots button,.sh>a,.vall,.gfs-v2 .chip,.gfs-v2 .htag,.hdt-menu-link,.hdt-heading-f.collapsible';
  var SKIP=':disabled,[disabled],[aria-disabled="true"],.disabled,.is-disabled,.jm-button--disabled,.skip-to-content-link';
  var MIN=120,cur=null,t0=0;
  document.addEventListener('touchstart',function(){},{passive:true});
  function find(t){
    var el=t&&t.closest?t.closest(SEL):null;if(!el)return null;
    try{if(el.matches(SKIP)||el.closest('.shopify-payment-button,shopify-buy-it-now-button'))return null}catch(e){}
    return el;
  }
  var host=null;
  function down(e){
    if(e.button>0)return;
    var path=e.composedPath?e.composedPath():[];
    for(var i=0;i<path.length&&i<6;i++){var n=path[i];if(n&&n.getAttribute&&/(^|\s)close-button(\s|$)/.test(n.getAttribute('part')||'')){var r=n.getRootNode();if(r&&r.host){release(true);host=r.host;t0=Date.now();host.classList.add('gfs-press-x');return}}}
    var el=find(e.target);if(!el)return;
    release(true);cur=el;t0=Date.now();el.classList.add('gfs-press');
  }
  function release(now){
    if(host){var h=host;host=null;var w=now?0:Math.max(0,MIN-(Date.now()-t0));if(w)setTimeout(function(){h.classList.remove('gfs-press-x')},w);else h.classList.remove('gfs-press-x')}
    var el=cur;if(!el)return;cur=null;
    var wait=now?0:Math.max(0,MIN-(Date.now()-t0));
    if(wait)setTimeout(function(){el.classList.remove('gfs-press')},wait);else el.classList.remove('gfs-press');
  }
  document.addEventListener('pointerdown',down,{passive:true,capture:true});
  ['pointerup','pointercancel','dragstart'].forEach(function(n){document.addEventListener(n,function(){release(false)},{passive:true,capture:true})});
  window.addEventListener('blur',function(){release(true)});
  document.addEventListener('scroll',function(){if(cur&&Date.now()-t0>MIN)release(true)},{passive:true,capture:true});
  document.addEventListener('keydown',function(e){if(e.key!==' '&&e.key!=='Enter')return;var el=find(e.target);if(el&&!el.classList.contains('gfs-press')){el.classList.add('gfs-press');setTimeout(function(){el.classList.remove('gfs-press')},MIN+40)}},true);
})();
